import React, { Component } from "react";
import {
  Grid,
  Row,
  Col,
  FormGroup,
  ControlLabel,
  FormControl,
  Alert
} from "react-bootstrap";

import { Card } from "components/Card/Card.jsx";
import { UserCard } from "components/UserCard/UserCard.jsx";
import Button from "components/CustomButton/CustomButton.jsx";
import validator from 'validator';

import defaultAvatar from "assets/img/default-avatar.png";

import { fetchUserRequest, editUserRequest } from "../api/user";
import { editEmployeeRequest } from "../api/employee";
import { getFullName } from '../helpers/functions/employee';

class UserProfile extends Component {
  
  constructor(props) {
    super(props);
    this.state = {
      resource: {},
      passwordEditEnabled: false,
      successMessage: null,
      errorMessage: null,
      currentPassword: null,
      newPassword: null,
      confirmNewPassword: null
    }
  }

  componentDidMount() {
    const {
      user
    } = this.props;

    if(user.userId) {
        this.fetchUser(user.userId)
    }
  }

  fetchUser = (id) => {
    fetchUserRequest(id, result => this.setState({resource: result}), error => console.log(error))
  }

  handleEmployeeFieldChange = (e) => {
    const { target } = e;
    const { name, value } = target;

    this.setState(prevState => ({
      resource: {
        ...prevState.resource,
        employee: {
          ...prevState.resource.employee,
          [name]: value
        }
      },
    }))
  }

  handlePasswordFieldChange = (e) => {
    const { target } = e;
    const { name, value } = target;

    this.setState({
      [name]: value
    })
  }

  togglePasswordEdit = () => {
    this.setState({
      passwordEditEnabled: !this.state.passwordEditEnabled
    })
  }

  errorMessage = (name, message) => {
    const { formErrors } = this.state;
    return (
        <>
        {formErrors &&
            formErrors[name] &&
            <div className='form-text text-danger sz-11px'>
            {message}
            </div>}
        </>
    );
  }

  validate = () => {

    const {
      employee={}
    } = this.state.resource;

    const { 
      passwordEditEnabled,
      currentPassword,
      newPassword,
      confirmNewPassword
    } = this.state;

    let errors = {};

    if (!employee.firstName || validator.isEmpty(employee.firstName)) {
      errors.firstName = true
    }

    if (!employee.lastName || validator.isEmpty(employee.lastName)) {
      errors.lastName = true
    }

    if (passwordEditEnabled) {
      if (!currentPassword || validator.isEmpty(currentPassword)) {
        errors.currentPassword = true
      }
  
      if (!newPassword || validator.isEmpty(newPassword)) {
        errors.newPassword = true
      }
  
      if (newPassword !== confirmNewPassword) {
        errors.confirmNewPassword = true
      }
    }

    if (Object.keys(errors).length > 0) {
      this.setState({ 
        formErrors: errors,
        successMessage: null,
        errorMessage: null
      })
    } else {
      this.setState({
        formErrors: null,
        successMessage: null,
        errorMessage: null
      })
      this.save()
    }
  }

  save = () => {

    const {
      _id,
      email,
      employee
    } = this.state.resource;

    const { 
      passwordEditEnabled,
      currentPassword,
      newPassword,
    } = this.state;

    editEmployeeRequest(employee._id, employee,
      result => this.saveSuccess(),
      error => this.saveFailure()
    );

    if (passwordEditEnabled) {

      const data = {
        email,
        currentPassword,
        newPassword
      }

      editUserRequest(_id, data,
        result => this.saveSuccess(),
        error => this.saveFailure()
      );
    }
  }

  saveSuccess = () => {
    this.setState({ 
      errorMessage: null,
      successMessage: "Saved successfully",
      passwordEditEnabled: false
    });
  }

  saveFailure = () => {
      this.setState({ 
        errorMessage: "There was an error saving",
        successMessage: null
      })
  }

  render() {

    const {
      email,
      role,
      employee={}
    } = this.state.resource;

    const {
      passwordEditEnabled,
      successMessage,
      errorMessage,
      currentPassword,
      newPassword,
      confirmNewPassword
    } = this.state;

    return (
      <div className="content">
        <Grid fluid>
          <Row>
            <Col md={8}>
              <Card
                title="Your Profile"
                content={
                  <form>
                    <Row>
                      <div className="col-md-6">
                        <FormGroup>
                          <ControlLabel>Company</ControlLabel>
                          <FormControl
                            type="text"
                            name="company"
                            value={employee.company ? employee.company.companyName : "N/A"}
                            readOnly
                            placeholder=""
                          />
                        </FormGroup>
                      </div>
                      <div className="col-md-6">
                        <FormGroup>
                          <ControlLabel>Role</ControlLabel>
                          <FormControl
                            type="text"
                            name="role"
                            value={role}
                            readOnly
                            placeholder=""
                          />
                        </FormGroup>
                      </div>
                    </Row>
                    <Row>
                      <div className="col-md-12">
                        <FormGroup>
                          <ControlLabel>Email Address</ControlLabel>
                          <FormControl
                            type="email"
                            name="email"
                            value={email}
                            readOnly
                            placeholder=""
                          />
                        </FormGroup>
                      </div>
                    </Row>
                    <Row>
                      <div className="col-md-4">
                        <FormGroup>
                          <ControlLabel>First Name</ControlLabel>
                          <FormControl
                            type="text"
                            name="firstName"
                            value={employee.firstName}
                            onChange={this.handleEmployeeFieldChange}
                            placeholder=""
                          />
                          {this.errorMessage('firstName', "First Name can't be empty")}
                        </FormGroup>
                      </div>
                      <div className="col-md-4">
                        <FormGroup>
                          <ControlLabel>Middle Name</ControlLabel>
                          <FormControl
                            type="text"
                            name="middleName"
                            value={employee.middleName}
                            onChange={this.handleEmployeeFieldChange}
                            placeholder=""
                          />
                        </FormGroup>
                      </div>
                      <div className="col-md-4">
                        <FormGroup>
                          <ControlLabel>Last Name</ControlLabel>
                          <FormControl
                            type="text"
                            name="lastName"
                            value={employee.lastName}
                            onChange={this.handleEmployeeFieldChange}
                            placeholder=""
                          />
                          {this.errorMessage('lastName', "Last Name can't be empty")}
                        </FormGroup>
                      </div>
                    </Row>
                    {passwordEditEnabled &&
                      <div>
                        <Row>
                          <div className="col-md-12">
                            <FormGroup>
                              <ControlLabel>Current Password</ControlLabel>
                              <FormControl
                                  type="password"
                                  name="currentPassword"
                                  value={currentPassword}
                                  onChange={this.handlePasswordFieldChange}
                              />
                              {this.errorMessage('currentPassword', "Current password provided is incorrect")}
                            </FormGroup>
                          </div>
                        </Row>
                        <Row>
                          <div className="col-md-12">
                            <FormGroup>
                              <ControlLabel>New Password</ControlLabel>
                              <FormControl
                                  type="password"
                                  name="newPassword"
                                  value={newPassword}
                                  onChange={this.handlePasswordFieldChange}
                              />
                            </FormGroup>
                          </div>
                        </Row>
                        <Row>
                          <div className="col-md-12">
                            <FormGroup>
                              <ControlLabel>Confirm New Password</ControlLabel>
                              <FormControl
                                  type="password"
                                  name="confirmNewPassword"
                                  value={confirmNewPassword}
                                  onChange={this.handlePasswordFieldChange}
                              />
                              {this.errorMessage('confirmNewPassword', "Passwords do not match")}
                            </FormGroup>
                          </div>
                        </Row>
                      </div>
                    }
                    {errorMessage &&
                        <Alert bsStyle="danger">
                            {errorMessage}
                        </Alert>
                    }
                    {successMessage &&
                        <Alert bsStyle="success">
                            {successMessage}
                        </Alert>
                    }
                    <Button
                      bsStyle="default" 
                      fill
                      onClick={this.togglePasswordEdit}
                    >
                      {passwordEditEnabled
                        ? 'Cancel'
                        : 'Change Password'
                      }
                    </Button>
                    <Button bsStyle="primary" pullRight fill onClick={this.validate}>
                      Update Profile
                    </Button>
                    <div className="clearfix" />
                  </form>
                }
              />
            </Col>
            <Col md={4}>
              <UserCard
                bgImage="https://ununsplash.imgix.net/photo-1431578500526-4d9613015464?fit=crop&fm=jpg&h=300&q=75&w=400"
                avatar={defaultAvatar}
                name={getFullName(employee)}
                userName={email}
              />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

export default UserProfile;
